import React from 'react'

// atomic components
import Section from 'components/atoms/Section'
import SectionItem from 'components/atoms/SectionItem'

// local components
import EmergencyContact from './EmergencyContact'

const AccountEmergencyContacts = props => {
  const {
    title,
    account,
    subheaderText,
    buttonText,
    buttonRoute,
    reupRequired,
    setModal,
    editable
  } = props

  return (
    <Section
      title={title}
      subheaderText={subheaderText}
      buttonText={buttonText}
      buttonRoute={buttonRoute}
    >
      {account.emergencyContacts.map(emergencyContact => (
        <SectionItem key={emergencyContact.id}>
          <EmergencyContact
            emergencyContact={emergencyContact}
            reupRequired={reupRequired}
            setModal={setModal}
            editable={editable}
          />
        </SectionItem>
      ))}
    </Section>
  )
}

export default AccountEmergencyContacts
